import React from "react";

export interface ButtonToolbarProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Button groups or buttons to arrange in a toolbar
   */
  children?: React.ReactNode;
  /**
   * Optional inline style overrides
   */
  style?: React.CSSProperties;
}

/**
 * A simple ButtonToolbar replacement for react-bootstrap's <ButtonToolbar>.
 * Arranges children horizontally with spacing, using only inline styles.
 */
const ButtonToolbar: React.FC<ButtonToolbarProps> = ({ children, style = {}, ...props }) => {
  const baseStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
    alignItems: 'center',
    ...style,
  };

  return (
    <div style={baseStyle} role="toolbar" {...props}>
      {children}
    </div>
  );
};

export default ButtonToolbar;
